import {ListsViewSettings, ListsViewSort, SortOrder} from "../ClientSidetypes";
import {ChangeEvent} from "react";

export default function ListsViewMenu(
    {
        currentOptions,
        onChange
    } : {
        currentOptions: ListsViewSettings
        onChange: (newListOptions: ListsViewSettings) => void
    }) {

    const currentlySelectedValue = currentOptions.sortOrderHistory.slice().reverse()[0];
    const radioButtonChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newSortOrder = {sortBy: event.target.value} as SortOrder
        const sortOrderHistory = currentOptions.sortOrderHistory.filter(a => a.sortBy !== newSortOrder.sortBy);
        sortOrderHistory.push(newSortOrder)

        onChange({...currentOptions, sortOrderHistory: sortOrderHistory} as ListsViewSettings);
    };

    const showRemovedListsChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange({...currentOptions, showRemovedLists: event.target.checked});
    }


    return (
        <>
            <menu id={"lists-view-menu"}>
                <fieldset>
                    <legend>Visa</legend>
                    <label>
                        <input type={"checkbox"} name={"ShowRemovedLists"} onChange={showRemovedListsChange} checked={currentOptions.showRemovedLists} />
                        Bortagna listor
                    </label>
                </fieldset>
                <fieldset>
                    <legend>Sortera</legend>
                    <ul>
                        <li>
                            <label>
                                <input type={"radio"} name={"sortBy"} value={ListsViewSort.CreatedAt} onChange={radioButtonChange} checked={currentlySelectedValue.sortBy === ListsViewSort.CreatedAt} />
                                Skapad
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type={"radio"} name={"sortBy"} value={ListsViewSort.ModifiedAt} onChange={radioButtonChange} checked={currentlySelectedValue.sortBy === ListsViewSort.ModifiedAt} />
                                Senast ändrad
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type={"radio"} name={"sortBy"} value={ListsViewSort.Name} onChange={radioButtonChange} checked={currentlySelectedValue.sortBy === ListsViewSort.Name} />
                                Namn
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type={"radio"} name={"sortBy"} value={ListsViewSort.Size} onChange={radioButtonChange} checked={currentlySelectedValue.sortBy === ListsViewSort.Size} />
                                Antal
                            </label>
                        </li>
                        <li>
                            <label>
                                <input type={"radio"} name={"sortBy"} value={ListsViewSort.CheckedCount} onChange={radioButtonChange} checked={currentlySelectedValue.sortBy === ListsViewSort.CheckedCount} />
                                Antal avbockade
                            </label>
                        </li>
                    </ul>
                </fieldset>
            </menu>
        </>
    );
}
